export enum Tier {
    Bronze = 1,
    Silver = 2,
    Gold = 3,
}